import Image from "next/image";
import Link from "next/link";
import { Heading } from "@/components/ui/Heading";
import { BannerData } from "@/core/types/about-us";
import CustomButton from "./CustomButton";

interface BannerProps {
  data: BannerData;
}

export default function Banner({ data }: BannerProps) {
  return (
    <div className="space-y-4">
      <div className="relative w-full max-h-[60vh] aspect-video rounded-md flex items-center justify-center p-8">
        {data.image && (
          <Image
            src={data.image?.url}
            alt={data.title || "some picture"}
            className="absolute w-full h-full object-cover rounded-md"
            fill
          />
        )}
        <div className="hidden absolute rtl:right-4 ltr:left-4 space-y-4 min-h-1/2 bg-secondary-100 rounded-md px-8 py-10 md:flex flex-col justify-between max-w-1/3">
          <div>
            <Heading
              level={1}
              className="text-primary-0 text-[calc(.8rem+0.3vw)]"
            >
              {data.title}
            </Heading>
            <p
              className="text-primary-100 text-sm"
            >
              {data?.subtitle}
            </p>
          </div>
          {((data.buttonContent && data.link) && data.link) && <CustomButton asChild variant="secondary">
            <Link href={data.link}>{data.buttonContent}</Link>
          </CustomButton>}
        </div>
      </div>
      <div className="space-y-4 min-h-1/2 bg-secondary-100 rounded-md px-8 py-10 flex md:hidden flex-col justify-between">
        <div>
          <Heading
            level={1}
            className="text-primary-0 text-[calc(.8rem+0.3vw)]"
          >
            {data.title}
          </Heading>
          <p
            className="text-primary-100 text-sm"
          >
            {data?.subtitle}
          </p>
        </div>
        {(data.buttonContent && data.link) && <CustomButton asChild variant="secondary">
          <Link href={data.link}>{data.buttonContent}</Link>
        </CustomButton>}
      </div>
    </div>
  );
}
